import React from 'react';
import cls from './PositionIItem.module.css';
import classNames from 'classnames';
import { usePlanFact } from '../../../hooks/usePlanFact';
import { ConnectionArrow } from '../ConnectionArrow/ConnectionArrow';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../../../../../store';

export const PlanFactPositionItem = ({
    position,
    positionX,
    chainPositionMove,
    leftForFact,
    elWidth,
}) => {
    const { activeTab } = useSelector((state) => state.gantReducer);

    const { connections: connectionsList } = useAppSelector(
        (state) => state.positionsConnectionsReducer
    );

    const connections = connectionsList.filter((connectionItem) => {
        return connectionItem.from === position.guid;
    });

    const ellipsis = 'ellipsis';
    const clip = 'clip';

    const { planWidth, factWidth, factLeft } = usePlanFact(position, 'position', activeTab);
    return (
        <div className={classNames(cls.wrapper)}>
            {connections.map((connectionItem) => (
                <ConnectionArrow
                    connection={connectionItem}
                    key={connectionItem.from + connectionItem.to + connectionItem.type}
                    positionX={positionX}
                    factLeft={factLeft}
                />
            ))}
            <div className={cls.planElementWrapper}>
                <div style={{ width: planWidth }} className={classNames(cls.planElement)}></div>
            </div>
            <div
                data-position-guid={position.guid}
                style={{ left: factLeft + 1 }}
                className={classNames(cls.StageItem, { [cls.planFact]: isPlanFact })}
            >
                {/*<ReactTooltip*/}
                {/*    id={`diagram-position-${position.guid}`}*/}
                {/*    aria-haspopup="true"*/}
                {/*    effect="solid"*/}
                {/*    delayHide={200}*/}
                {/*    delayShow={200}*/}
                {/*    type="light"*/}
                {/*    className={cls.tooltip}*/}
                {/*>*/}
                {/*    <p>{position.name}</p>*/}
                {/*</ReactTooltip>*/}
                <div
                    data-tip
                    title={position.name}
                    data-for={`diagram-position-${position.guid}`}
                    style={{
                        width: factWidth,
                        cursor: 'auto',
                        '--width': position.done_percent,
                        '--name': `"${position.name}"`,
                        '--ellipsis': `${position.done_percent > 96 ? ellipsis : clip}`,
                    }}
                    className={classNames(cls.MainElementProgress, [cls[position.type]], {
                        [cls.backgroundFact]: isPlanFact,
                        [cls.canceled]: isPlanFact && position.is_canceled,
                        [cls.notPadding]: activeTab !== 'day' && +position.actual?.days_count < 3,
                    })}
                >
                    <div className={classNames(cls.textProgress, cls.blackText)}>
                        <div>{position?.name}</div>
                    </div>
                    <div
                        className={classNames(cls.progressBar)}
                        style={{ width: `${position.done_percent}%` }}
                    ></div>
                    {!!+position.done_percent > 0 && (
                        <div
                            style={{ width: `${position.done_percent}%` }}
                            className={classNames(cls.textProgress, cls.whiteText, [
                                cls[position.type],
                            ])}
                        >
                            <div>{position?.name}</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
